<template>
  <div class="notification-icon"
       @focusout="hideNotifications($event)"
       tabindex="0">
    <a @click="showNotifications()">
      <span class="notification-dot" v-show="unread.comment || unread.like"></span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 15">
        <g>
          <g>
            <g>
              <path fill="#141124"
                    d="M6.835 15.494a1.14 1.14 0 1 0 2.279 0v-.456H6.835zM7.975 0a5.674 5.674 0 0 1 5.65 5.16l.407 4.476c.036.393.272.74.625.916l.003.001a2.332 2.332 0 0 1 1.29 2.086v.348a2.05 2.05 0 0 1-2.051 2.051H10.48v.456a2.506 2.506 0 1 1-5.013 0v-.456H2.051A2.05 2.05 0 0 1 0 12.988v-.349c0-.883.5-1.69 1.29-2.086l.002-.001a1.14 1.14 0 0 0 .626-.916l.406-4.476A5.674 5.674 0 0 1 7.974 0zm0 1.367a4.306 4.306 0 0 0-4.29 3.917L3.28 9.76a2.506 2.506 0 0 1-1.375 2.014.967.967 0 0 0-.537.865v.348c0 .378.306.684.684.684h11.848a.684.684 0 0 0 .683-.684v-.348c0-.365-.206-.7-.533-.863A2.508 2.508 0 0 1 12.67 9.76l-.407-4.476a4.306 4.306 0 0 0-4.288-3.917z"/>
            </g>
          </g>
        </g>
      </svg>
    </a>
    <div class="dropdown-box collapse notification-card" id="navbarNotificationsContent"
         ref="notificationWindow">
      <div class="notification-dropdown">
        <div class="notification-title">
          <div class="row">
            <h6 class="col-md-6">Notifications</h6>
            <p class="col-md-6 text-right"><a @click="markAllRead()" class="text-primary" :disabled="!unread.length">Mark
              all as read.</a></p>
          </div>
        </div>
        <div class="notification-wrapper" v-if="Object.keys(unread).length || Object.keys(read).length">
          <div class="notification-list" v-for="(commentNotifs, doc_id) in unread.comment">
            <div class="icon-notification">
              <img src="/assets/img/bubble-icon.svg" alt="">
            </div>
            <div class="notification-info">
              <a @click="markRead(commentNotifs[0].id)">
                <h6>{{ commentNotifs[0].data.name }}</h6>
                <p>
                  {{ commentNotifs.length }} New Comment<span v-if="commentNotifs.length > 1">s</span>
                </p>
              </a>
            </div>
          </div>
          <div class="notification-list" v-for="(commentNotifs, doc_id) in unread.like">
            <div class="icon-notification">
              <img src="/assets/img/wishlist-icon-full.svg" alt="">
            </div>
            <div class="notification-info">
              <a @click="markRead(commentNotifs[0].id)">
                <h6>{{ commentNotifs[0].data.name }}</h6>
                <p>
                  {{ commentNotifs.length }} New Like<span v-if="commentNotifs.length > 1">s</span>
                </p>
              </a>
            </div>
          </div>
          <div class="notification-list" v-for="(commentNotifs, doc_id) in read.comment">
            <div class="icon-notification">
              <img src="/assets/img/bubble-icon.svg" alt="">
            </div>
            <div class="notification-info">
              <a :href="'/document/' + doc_id">
                <h6>{{ commentNotifs[0].data.name }}</h6>
                {{ commentNotifs.length }} Comment<span v-if="commentNotifs.length > 1">s</span>
              </a>
            </div>
          </div>
          <div class="notification-list" v-for="(commentNotifs, doc_id) in read.like">
            <div class="icon-notification">
              <img src="/assets/img/wishlist-icon.svg" alt="">
            </div>
            <div class="notification-info">
              <a :href="'/document/' + doc_id">
                <h6>{{ commentNotifs[0].data.name }}</h6>
                {{ commentNotifs.length }} Like<span v-if="commentNotifs.length > 1">s</span>
              </a>
            </div>
          </div>
        </div>
        <div class="notification-no-document" v-else
             style="background-image: url('/assets/img/crow_notifications-img.jpg');">
          <div class="no-notification">
            <p>No documents have any<br> comments or likes yet</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../api/api.service";

import ClickOutside from 'vue-click-outside'

export default {
  name: "Notifications",
  data() {
    return {
      unread: {},
      read: {},
      showNotifs: false,

    };
  },
  mounted() {
    this.getNotifications();
  },
  methods: {
    getNotifications() {
      ApiService.setHeader();
      ApiService.post('/api/notifications')
          .then(({data}) => {
            this.unread = data.unread || {};
            this.read = data.read || {};
          })
          .catch((res) => {
            console.log(res);
          });
    },

    markAllRead() {
      ApiService.setHeader();
      ApiService.post('/api/notifications/mark-read')
          .then(({data}) => {
            this.getNotifications();
          })
          .catch((res) => {
            console.log(res);
          });
    },

    markRead(id) {
      ApiService.setHeader();
      ApiService.post('/api/notifications/' + id)
          .then(({data}) => {
            this.getNotifications();
            let newUrl = '/document/' + data.data.document_id;
            if (this.$route.path != newUrl) {
              this.$router.replace(newUrl);
              location.reload()
            }


          })
          .catch((res) => {
            console.log(res);
          });
    },
    showNotifications() {
      this.$refs.notificationWindow.classList.toggle('show');
    },
    hideNotifications(e) {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        this.$refs.notificationWindow.classList.remove('show');
      }
    },
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped>

</style>
